import { useThirdPartyOrganization } from 'bundles/enterprise-admin/ThirdPartyOrganizationProvider';
import { IdTypes, createFeatureScope } from 'bundles/product-features';

const { useProductFeatures } = createFeatureScope({
  enterprise: {
    enableUnifiedSso: false,
  },
});

const useProductFeature = () => {
  const { id: thirdPartyOrganizationId } = useThirdPartyOrganization();
  const { features, loading: isFeatureFlagLoading } = useProductFeatures({
    idType: IdTypes.Organization,
    id: thirdPartyOrganizationId,
    ssr: true,
  });

  const enableUnifiedSso = features.get('enterprise', 'enableUnifiedSso');

  return {
    isFeatureFlagLoading,
    isUnifiedSsoEnabled: enableUnifiedSso,
  };
};

export default useProductFeature;
